
import { useState, useEffect } from 'react';
import { useTranslation } from '@/context/TranslationContext';
import styles from './CookieBanner.module.scss';

export default function CookieBanner() {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAcceptAll = () => {
        localStorage.setItem('cookie_consent', 'all');
        setIsVisible(false);
        window.location.reload(); // Reload to trigger tracking
    };

    const handleNecessary = () => {
        localStorage.setItem('cookie_consent', 'necessary');
        setIsVisible(false);
        window.location.reload(); // Reload to ensure no tracking scripts run
    };

    if (!isVisible) return null;

    return (
        <div className={styles.cookieBanner}>
            <div className={styles.content}>
                <h3>{t('COOKIE.TITLE')}</h3>
                <p>{t('COOKIE.TEXT')}</p>
                <div className={styles.actions}>
                    <button onClick={handleNecessary} className={styles.btnNecessary}>
                        {t('COOKIE.NECESSARY')}
                    </button>
                    <button onClick={handleAcceptAll} className={styles.btnAccept}>
                        {t('COOKIE.ACCEPT_ALL')}
                    </button>
                </div>
            </div>
        </div>
    );
}
